import React from 'react'
import QR from 'qrcode.react'

const QRCode = props => {
  if (!props.value) {return null}

  return (
    <QR id="PrimeQR" renderAs='svg' size='300' fgColor={'#111'} value={props.value} />
  )
}

export default QRCode
